import React from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import markdownit from 'markdown-it';
import { useMemoizedFn } from 'ahooks';
import { PdfGenerator } from '../utils/Markdown2PDF';
// 初始化markdown-it渲染器并启用图片加载
const md = markdownit({
    html: true,
    breaks: true,
    linkify: true,
    typographer: true,
});

interface PdfDownloadButtonProps {
    content: string;
    title?: string;
    footer?: string;
    fileName?: string;
}

/**
 * PDF下载按钮组件，用于将文本内容下载为PDF文件
 */
const PdfDownloadButton: React.FC<PdfDownloadButtonProps> = ({
    content,
    title = '福利助手回复',
    footer = `生成时间：${new Date().toLocaleDateString()}`,
    fileName = `福利助手回复-${new Date().getTime()}.pdf`
}) => {
    if (!content) {
        return (
            <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => console.error("没有找到可下载的文本内容")}
                className="message-action-button"
            >
                下载
            </Button>
        );
    }

    const handleGeneratePdf = useMemoizedFn(() => {
        PdfGenerator.generatePdf(content);
    });

    return (
        <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleGeneratePdf}
            className="message-action-button"
        >
            下载
        </Button>
    );
};

export default PdfDownloadButton; 